export default {
  vehicleYear: "VehicleYear",
  AddVehicleYear: "AddVehicleYear",
  editVehicleYear: "EditVehicleYear",
};
